import styled from '@emotion/styled';

export const StyledHeaderContent = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'space-between',
  width: '100%',
});

export const StyledHeaderBrand = styled('div')({
  alignItems: 'center',
  display: 'flex',
  gap: 16,
});

export const StyledLogo = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.cyan[6],
  color: theme.white,
  display: 'flex',
  height: 36,
  justifyContent: 'center',
  width: 36,
}));

export const StyledHeadingBlock = styled('div')({
  lineHeight: 1.2,
});

export const StyledHeading = styled('div')({
  fontSize: '0.875rem',
  fontWeight: 600,
  lineHeight: 1.2,
});

export const StyledSubheading = styled('div')(({ theme }) => ({
  color:
    theme.colorScheme === 'dark' ? theme.colors.gray[5] : theme.colors.gray[6],
  fontSize: '0.75rem',
  lineHeight: 1.2,
}));
